import React, { useState, useEffect } from "react";
import "./midofficepages.css";
import MoSidebar from "../Sidebar/MoSidebar";
import { Navigate, Route, Routes } from "react-router-dom";
import MoHeader from "../Header/MoHeader";
import OrderPageIntegration from "../orders/OrderPageIntegration";
import RestaurantApprovals from "../RestaurantApprovals/RestaurantApprovals";
import ComplaintHandling from "./ComplaintHandlingpage";
import EatitGame from "./EatitGame";
import api from "../../services/api";
import useSupportWebSocket from "../../hooks/useSupportWebSocket";
import { useDispatch } from "react-redux";
import { setRequestApproval } from "../../redux/Slice/requestApproval";

function MidOfficePagesIntegration() {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const dispatch = useDispatch();

  // Initialize WebSocket connection for Mid-Office
  useSupportWebSocket('mid-office');

  // Close sidebar if screen width is less than 1024px
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 1024) {
        setIsSidebarOpen(false); // Automatically close the sidebar
      } else {
        setIsSidebarOpen(true); // Keep sidebar open for larger screens
      }
    };

    handleResize(); // Call on initial render
    window.addEventListener("resize", handleResize); // Add resize listener

    return () => {
      window.removeEventListener("resize", handleResize); // Cleanup listener
    };
  }, []);

  // Fetch restaurant approvals
  function fetchRestaurantApprovals() {
    api
      .get("/getresaurantApprovals")
      .then((res) => {
        dispatch(setRequestApproval(res.data.vendor));
        console.log(res.data.vendor);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  useEffect(() => {
    fetchRestaurantApprovals();
  }, []);

  return (
    <div className="MidofficePagesInteegrationMainClass">
      {isSidebarOpen && <MoSidebar />}

      {/*      <div style={{ display: "flex" }}>
       {isSidebarOpen && (
          <div className="SideBar" style={{ maxWidth: "240px" }}>
            <MoSidebar />
          </div>
        )}
        <div className="Header" style={{ flex: "1" }}>
          <MoHeader setIsSidebarOpen={setIsSidebarOpen} />
        </div>
      </div> */}
      <div className="RightContent">
        <MoHeader setIsSidebarOpen={setIsSidebarOpen} />
        <h1>content</h1>
        <Routes>
          <Route path="/" element={<Navigate to={"orders"} />} />
          <Route path="orders" element={<OrderPageIntegration />} />
          <Route path="complaints/*" element={<ComplaintHandling />} />
          <Route
            path="restaurants-approvals"
            element={<RestaurantApprovals />}
          />
          <Route path="analytics" element={<h1>analytics</h1>} />
          <Route path="eatit-game" element={<EatitGame />} />
        </Routes>
      </div>
    </div>
  );
}

export default MidOfficePagesIntegration;
